import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93f56280"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "card-footer" }

import { onBeforeMount, onBeforeUpdate, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  name: 'player-tile.component',
  props: {
  item: Object,
  loading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onUpdate", "onPreview"],
  setup(__props, { emit }) {

const props = __props





let ScreenshotThmbUrl = ref();

function onPreview() {
  console.log("on preview click");
  emit("onPreview", props.item);
}

onBeforeMount(() => (ScreenshotThmbUrl.value = props.item?.ScreenshotThmbUrl));

onBeforeUpdate(async () => {
  ScreenshotThmbUrl.value = props.item?.ScreenshotThmbUrl;
  emit("onUpdate", props.item);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "card",
    style: _normalizeStyle(!__props.item.Online ? { borderColor: 'red' } : {})
  }, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("img", {
        class: _normalizeClass(["ss-grid", { empty: _unref(ScreenshotThmbUrl) === undefined }]),
        src: 
          _unref(ScreenshotThmbUrl) !== undefined
            ? _unref(ScreenshotThmbUrl)
            : require('@/assets/icons/no-image-icon.png')
        ,
        onError: _cache[0] || (_cache[0] = 
          (e) => (
            (e.target.src = `${require('@/assets/icons/no-image-icon.png')}`),
            (e.target.className += ' empty')
          )
        ),
        onClick: onPreview
      }, null, 42, _hoisted_5),
      _createElementVNode("span", null, [
        _createVNode(_component_router_link, {
          to: {
            name: 'PlayerInnerPage',
            params: { id: __props.item.id },
          }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.item.Name), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", null, "Heartbeat: " + _toDisplayString(__props.item.LastHeartbeat), 1)
    ])
  ], 4))
}
}

})